/**
 * Dwell collection — force filters LEFT, products RIGHT
 * Restructures DOM when theme keeps horizontal facets inside product-grid-container
 */
(function () {
  var BP = 990;

  function moveNode(node, parent) {
    if (node && parent && node.parentElement !== parent) {
      parent.appendChild(node);
    }
  }

  function applyLayout() {
    var wrappers = document.querySelectorAll('.collection-wrapper');
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      var isMobile = window.innerWidth < BP;
      var existingShell = wrapper.querySelector(':scope > .zava-collection-shell');

      if (isMobile) {
        wrapper.classList.remove('zava-layout-ready');
        if (existingShell) {
          while (existingShell.firstChild) {
            wrapper.insertBefore(existingShell.firstChild, existingShell);
          }
          existingShell.remove();
        }
        return;
      }

      var facets =
        wrapper.querySelector('.facets--vertical') ||
        wrapper.querySelector('.facets--horizontal') ||
        wrapper.querySelector('facets-form') ||
        wrapper.querySelector('.facets-wrapper') ||
        wrapper.querySelector('[class*="facets-block"]') ||
        wrapper.querySelector('.facets');

      var gridContainer = wrapper.querySelector('.product-grid-container');
      var productGrid = wrapper.querySelector('.product-grid, ul.product-grid');

      if (!productGrid) return;

      if (!facets && gridContainer) {
        facets =
          gridContainer.querySelector('.facets--vertical') ||
          gridContainer.querySelector('.facets--horizontal') ||
          gridContainer.querySelector('facets-form') ||
          gridContainer.querySelector('.facets-wrapper') ||
          gridContainer.querySelector('.facets');
      }

      var shell = existingShell;
      if (!shell) {
        shell = document.createElement('div');
        shell.className = 'zava-collection-shell';
        shell.innerHTML =
          '<aside class="zava-collection-shell__sidebar"></aside>' +
          '<div class="zava-collection-shell__main"></div>';

        while (wrapper.firstChild) {
          shell.querySelector('.zava-collection-shell__main').appendChild(wrapper.firstChild);
        }
        wrapper.appendChild(shell);
      }

      var sidebar = shell.querySelector('.zava-collection-shell__sidebar');
      var main = shell.querySelector('.zava-collection-shell__main');

      if (facets) {
        moveNode(facets, sidebar);
        facets.classList.add('zava-facets-in-sidebar');
      }

      if (gridContainer) {
        moveNode(gridContainer, main);
      } else if (productGrid.parentElement) {
        moveNode(productGrid.parentElement, main);
      }

      wrapper.classList.add('zava-layout-ready');
    });
  }

  function markCards() {
    document.querySelectorAll('product-card.product-card').forEach(function (card) {
      card.classList.add('zava-card-ready');
    });
  }

  function boot() {
    applyLayout();
    markCards();
  }

  boot();
  window.addEventListener('resize', applyLayout);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('filter:updated', boot);

  var target = document.querySelector('.collection-wrapper, results-list');
  if (target && window.MutationObserver) {
    new MutationObserver(function () {
      boot();
    }).observe(target, { childList: true, subtree: true });
  }
})();
